import React from 'react';
import { SelectListItemDescription, SelectListItemElement, SelectListItemContainer, } from './select.styles.js';
export const SelectListItem = ({ item }) => (React.createElement(SelectListItemContainer, { elementType: 'span', gapBetweenChildren: 'x1' },
    React.createElement(SelectListItemElement, { startIcon: item.startIcon }, item.label),
    item.description ? (React.createElement(SelectListItemDescription, null, item.description)) : null));
//# sourceMappingURL=select-list-item.component.js.map